import http from '../http-common'

class InfoService {
  log(info) {
    return http.post('/infolog', info)
  }
}

export default new InfoService()
